(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.pvLagerdato) return;
    var MND = ['januar','februar','mars','april','mai','juni','juli','august','september','oktober','november','desember'];
    var MK = ['jan.','feb.','mars','apr.','mai','juni','juli','aug.','sep.','okt.','nov.','des.'];
    function idag() { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function forste(liste) {
      var i = idag(), best = '';
      (liste || '').split(',').forEach(function (d) { d = d.trim(); if (/^\d{4}-\d{2}-\d{2}$/.test(d) && d >= i && (!best || d < best)) best = d; });
      return best;
    }
    function tekst(d, kort) {
      var p = d.split('-'), y = +p[0], m = +p[1] - 1, dag = +p[2];
      var s = dag + '. ' + (kort ? MK[m] : MND[m]);
      if (y !== new Date().getFullYear()) s += ' ' + y;
      return s;
    }
    function produkt() {
      document.querySelectorAll('.pv-levering').forEach(function (el) {
        var span = el.querySelector('[data-lagerdato]');
        var mal = el.querySelector('.pv-levering__status-tekst');
        if (!span || !mal) return;
        if (!mal.hasAttribute('data-original')) mal.setAttribute('data-original', mal.textContent);
        var d = el.classList.contains('pv-levering--utsolgt') ? forste(span.getAttribute('data-lagerdato')) : '';
        var ny = d ? 'Utsolgt - forventes på lager ' + tekst(d, false) : mal.getAttribute('data-original');
        if (mal.textContent !== ny) mal.textContent = ny;
        el.classList.toggle('pv-levering--har-dato', !!d);
      });
    }
    function kort() {
      document.querySelectorAll('.pv-kort-lagerdato').forEach(function (el) {
        var d = forste(el.getAttribute('data-lagerdatoer'));
        var ny = d ? 'Forventes ' + tekst(d, true) : '';
        if (el.textContent !== ny) el.textContent = ny;
        if (el.hidden !== !d) el.hidden = !d;
      });
    }
    function alt() { produkt(); kort(); }
    window.pvLagerdato = alt;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alt); else alt();
    document.addEventListener('variant:update', function () { setTimeout(produkt, 0); setTimeout(produkt, 300); });
    var tid;
    new MutationObserver(function () { clearTimeout(tid); tid = setTimeout(kort, 150); }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
